module.exports = __webpack_public_path__ + "2352d380b762417fe4a290d91087a889.png";